// extracted by mini-css-extract-plugin
module.exports = {"button":"KebabMenu_button__2TeXW"};